import {Fill, Stroke, Style} from "ol/style";
import CircleStyle from "ol/style/Circle";

export function getDefaultStyleFunction() {
    return function (feature) {
        return getDefaultStyles()[feature.getGeometry().getType()];
    }
}

export function getDefaultStyles() {

    const color = '#02bc77'
    const filColor = 'rgb(2,188,119, 0.1)'

    const image = new CircleStyle({
        radius: 18,
        fill: new Fill({
            color: filColor
        }),
        stroke: new Stroke({
            color: color,
            width: 4
        }),
    });

    return {
        'Point': new Style({
            image: image,
        }),
        'LineString': new Style({
            stroke: new Stroke({
                color: color,
                width: 1,
            }),
        }),
        'MultiLineString': new Style({
            stroke: new Stroke({
                color: color,
                width: 3,
            }),
        }),
        'MultiPoint': new Style({
            image: image,
        }),
        'MultiPolygon': new Style({
            stroke: new Stroke({
                color: color,
                lineDash: [4],
                width: 3,
            }),
            fill: new Fill({
                color: filColor
            }),
        }),
        'Polygon': new Style({
            stroke: new Stroke({
                color: color,
                lineDash: [4],
                width: 3,
            }),
            fill: new Fill({
                color: filColor
            }),
        }),
        'GeometryCollection': new Style({
            stroke: new Stroke({
                color: 'magenta',
                width: 2,
            }),
            fill: new Fill({
                color: 'magenta',
            }),
            image: new CircleStyle({
                radius: 10,
                fill: null,
                stroke: new Stroke({
                    color: color,
                }),
            }),
        }),
        'Circle': new Style({
            stroke: new Stroke({
                color: color,
                width: 2,
            }),
            fill: new Fill({
                color: filColor
            }),
        }),
    };

}
